export default __webpack_public_path__ + "static/media/element_63.ee4f7086.avif";